import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType } from "../../features/types";

// Flatten the structure to match other language files
export const common = {
  // Add navigation section
  navigation: {
    dashboard: "Panel",
    profile: "Perfil",
    signOut: "Cerrar sesión"
  },
  // Add profile section
  profile: {
    title: "Perfil",
    dangerZone: "Zona de Peligro",
    deleteAccount: "Eliminar Cuenta",
    confirmDelete: "Confirmar Eliminación",
    deleteWarning: "¿Está seguro de que desea eliminar su cuenta? Esta acción no se puede deshacer.",
    confirmDeleteButton: "Eliminar Cuenta",
    accountDeleted: "Cuenta Eliminada",
    accountDeletedMessage: "Su cuenta ha sido eliminada con éxito."
  },
  // Move these from nested common to root
  loading: "Cargando...",
  error: "Error",
  success: "Éxito",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  deleteConfirmation: "Confirmar Eliminación",
  deleteConfirmationMessage: "¿Estás seguro de que quieres eliminar",
  edit: "Editar",
  create: "Crear",
  update: "Actualizar",
  submit: "Enviar",
  confirm: "Confirmar",
  back: "Atrás",
  next: "Siguiente",
  finish: "Finalizar",
  close: "Cerrar",
  search: "Buscar",
  filter: "Filtrar",
  sort: "Ordenar",
  view: "Ver",
  settings: "Configuración",
  language: "Idioma",
  theme: "Tema",
  logout: "Cerrar sesión",
  home: "Inicio",
  notifications: "Notificaciones",
  messages: "Mensajes",
  help: "Ayuda",
  about: "Acerca de",
  contact: "Contacto",
  privacyPolicy: "Política de privacidad",
  termsOfService: "Términos de servicio",
  noResults: "No se encontraron resultados",
  noData: "No hay datos disponibles",
  required: "Requerido",
  optional: "Opcional",
  // Add errors section
  errors: {
    error: "Error",
    notFound: "Página no encontrada",
    deleteAccountError: "Hubo un error al eliminar su cuenta. Por favor, inténtelo de nuevo.",
    loadStoryError: "Error al cargar la historia. Por favor, inténtelo de nuevo.",
    loadCharactersError: "Error al cargar los personajes. Por favor, inténtelo de nuevo.",
    summaryError: "Error al generar el resumen. Por favor, inténtelo de nuevo.",
    required: "Este campo es requerido",
    invalid: "Este campo no es válido",
    minLength: "Debe tener al menos {min} caracteres",
    maxLength: "Debe tener como máximo {max} caracteres",
    email: "Debe ser un correo electrónico válido",
    password: "La contraseña debe tener al menos 8 caracteres",
    passwordMatch: "Las contraseñas no coinciden",
    generic: "Algo salió mal. Por favor, inténtalo de nuevo"
  },
  // Move status to root level
  status: {
    active: "Activo",
    inactive: "Inactivo",
    pending: "Pendiente",
    completed: "Completado",
    failed: "Fallido",
    error: "Error",
    success: "Éxito"
  }
};
